import { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'

import Tooltip from '@/components/Tooltip'
import { selectIsAdmin, selectPlanType } from '@/store/features/user/userSlice'
import { PlanType } from '@/types'

interface PermissionTooltipProps {
  enterpriseOnly?: boolean
  adminOnly?: boolean
}

const PermissionTooltip = (props: PropsWithChildren<PermissionTooltipProps>): React.ReactElement => {
  const { children, enterpriseOnly = false, adminOnly = true } = props
  const planType = useSelector(selectPlanType)
  const isAdmin = useSelector(selectIsAdmin)

  // Prioritize nudging users to upgrade to Enterprise plan over being an admin
  if (enterpriseOnly && planType !== PlanType.Enterprise) {
    return (
      <Tooltip text="Upgrade to Enterprise plan to modify this" placement="top" hideArrow>
        {children}
      </Tooltip>
    )
  }

  if (adminOnly && !isAdmin) {
    return (
      <Tooltip text="Only admins can modify this" placement="top" hideArrow>
        {children}
      </Tooltip>
    )
  }

  return children as React.ReactElement
}

export default PermissionTooltip
